<template>
    <b-row>
        <b-col class="text-center px-2">
            <div v-if="answered" class="content-pipu d-flex align-items-center justify-content-center">
                <b-card class="text-20 shadow-none">
                    <b-card-text class="text-30">Obrigado pela sua participação!</b-card-text>
                </b-card>
            </div>
            <div v-else class="content-pipu">
                <b-overlay :show="loading" rounded="sm" opacity="0.60" spinner-variant="primary">
                    <b-card
                        class="p-0 shadow-none"
                        no-body
                    >
                    <b-card-title class="order-1 mb-5">Como você se sentiu em relação a essa semana de trabalho?</b-card-title>
                    <div class="d-flex order-0 justify-content-end">
                        <div class="box-top bg-gray-200 py-3">
                            <span>
                                Seu perfil está <b>{{ identifiable }}</b>, gostaria de
                                <b-button
                                    variant="link"
                                    class="p-0"
                                    @click="identify = !identify"
                                >
                                    alterar
                                </b-button>?
                            </span>
                        </div>
                    </div>
                    <div class="order-2">
                        <b-button
                            class="btn-icon m-2 btn-response"
                            v-for="emoji in emojis"
                            :key="emoji.index"
                            :variant="emoji.index == response ? 'cyan-light' : 'outline-light'"
                            @click="chosen(emoji.index)"
                        >
                            <response-emoji
                                :response="emoji.index"
                                :hasText="true"
                                size="30px"
                            />
                        </b-button>
                    </div>
                    <div class="mt-4 order-3">
                        <b-card class="shadow-none">
                            <b-row align-h="center">
                                <b-col md="10" lg="8" class="bg-gray-200 pt-4 pb-1 px-4 rounded-top">
                                    <p class="text-left">Nos ajude a melhorar, comentando abaixo o porquê você se sente "{{ emojis.find(element => element.index === this.response).text }}"? (Opcional)</p>
                                    <b-form-textarea
                                        id="textarea"
                                        v-model="description"
                                        rows="3"
                                        max-rows="6"
                                        class="overflow-auto w-100"
                                        @keydown.ctrl.enter.prevent="answer(true)"
                                        @keydown.meta.enter.prevent="answer(true)"
                                        @keydown.enter.exact.prevent="$refs.answerButton.focus()"
                                    ></b-form-textarea>
                                </b-col>
                            </b-row>
                            <b-row align-h="center">
                                <b-col md="10" lg="8" class="bg-gray-200 py-4 px-4 text-right rounded-bottom">
                                    <span class="mr-2 text-light text-12">Fique tranquilo, sua resposta será anônima!</span>
                                    <b-button
                                        @click="answer(true)"
                                        ref="answerButton"
                                        variant="primary"
                                    >
                                        Responder
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-card>
                    </div>
                    </b-card>
                </b-overlay>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import api from '@/api/api'
export default {
    name: 'Response',
    components: {
        ResponseEmoji: () => import('@/components/Emojis/ResponseEmoji'),
    },
    data () {
        return {
            answered: false,
            description: '',
            emojis: [
                {
                    index: 3,
                    text: 'incrível',
                },
                {
                    index: 2,
                    text: 'feliz',
                },
                {
                    index: 1,
                    text: 'regular',
                },
                {
                    index: 0,
                    text: 'infeliz',
                },
            ],
            pulse: '',
            response: null,
            uid: '',
            identify: false,
            loading: false,
        }
    },
    methods: {
        chosen (choose) {
            this.response = choose
        },
        answer (saveByButton = false) {
            if (this.loading) return
            this.loading = true

            api
                .post(`/response/${this.pulse}/${this.uid}/${this.response}`, {
                    description: this.description,
                    saveByButton: saveByButton,
                    identify: this.identify,
                })
                .then(() => {
                    if (saveByButton) {
                        this.answered = true
                    }

                    this.loading = false
                })
        },
    },
    computed: {
        identifiable () {
            return this.identify ? 'identificado' : 'anônimo'
        },
    },
    watch: {
        identify (value) {
            localStorage.identify = value
        },
    },
    created () {
        this.pulse = this.$route.params.pulse
        this.response = +this.$route.params.response
        this.uid = this.$route.params.uid

        if (localStorage.identify) {
            this.identify = JSON.parse(localStorage.identify)
        }
    },
}
</script>
<style lang="scss">
    .btn-response {
        min-width: 140px;
    }
    @media (max-width(var(--breakpoint-sm))) {
        .container {
            margin: 0.5rem;
        }
    }
    @media (min-width(var(--breakpoint-sm))) and (max-width(var(--breakpoint-xl))){
        .container {
            margin: 0.5rem 1rem;
        }
    }
    @media (min-width(var(--breakpoint-xl))) {
        .container {
            margin: 0.5rem 3rem;
        }
    }

    .box-top {
        width: 30%;
        min-width: 200px;
    }

    .content-pipu {
        height: 33rem;
    }
</style>
